webpackJsonp([232136438209958],{

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _presets = __webpack_require__(3);
	
	var _functions = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var speed = _presets.animation.speed,
	    curve = _presets.animation.curve;
	
	
	var spacing = (0, _functions.fp)({
	  margin: [(0, _functions.toRem)(_presets.baselineGrid * 2) + ' auto ' + (0, _functions.toRem)(_presets.baselineGrid * 6), (0, _functions.toRem)(_presets.baselineGrid * 4) + ' auto ' + (0, _functions.toRem)(_presets.baselineGrid * 8), (0, _functions.toRem)(_presets.baselineGrid * 5) + ' auto ' + (0, _functions.toRem)(_presets.baselineGrid * 10), (0, _functions.toRem)(_presets.baselineGrid * 8) + ' auto ' + (0, _functions.toRem)(_presets.baselineGrid * 12)]
	});
	
	var animatedHeading = /*#__PURE__*/(0, _emotion.css)(spacing, ';width:80%;max-width:', (0, _functions.toRem)(_presets.baselineGrid * 120), ';font-size:calc(', (0, _functions.toRem)(_presets.baselineGrid * 3), ' + ', (0, _functions.toVW)(_presets.baselineGrid * 2), ');text-align:center;line-height:1.2;', 'label:animatedHeading;');
	
	var outerCell = /*#__PURE__*/(0, _emotion.css)('display:inline-block;overflow:hidden;&.word{margin-right:-0.02em;}', 'label:outerCell;');
	
	var slideUp = /*#__PURE__*/(0, _emotion.keyframes)('from{opacity:0;transform:translate3d(0,60%,0);}to{opacity:1;transform:translate3d(0,0,0);}', 'label:slideUp;');
	
	var innerCell = /*#__PURE__*/(0, _emotion.css)('display:inline-block;animation:', slideUp, ' ', speed.medium, ' ', curve.default, ' both;', 'label:innerCell;');
	
	var AnimatedHeading = function (_Component) {
	  _inherits(AnimatedHeading, _Component);
	
	  function AnimatedHeading() {
	    _classCallCheck(this, AnimatedHeading);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  AnimatedHeading.prototype.render = function render() {
	    var _this2 = this;
	
	    var breakLine = /*#__PURE__*/(0, _emotion.css)('display:block;height:0;margin-top:-0.125em;overflow:hidden;', 'label:breakLine;');
	
	    if (this.props.animated) {
	      return _react2.default.createElement(
	        'h1',
	        { className: animatedHeading, 'aria-label': this.props.text },
	        this.chunks.map(function (string, idx) {
	          var _cx;
	
	          return _react2.default.createElement(
	            'span',
	            {
	              key: idx,
	              className: (0, _emotion.merge)((0, _emotion.css)( /*#__PURE__*/(0, _emotion.css)('span{animation-delay:', 200 + 35 * idx, 'ms;}', 'label:AnimatedHeading;')) + (' ' + (0, _emotion.cx)(outerCell, function () {
	                return _this2.props.splitAtWords ? 'word' : 'letter';
	              }, 'count-' + (idx + 1), (_cx = {}, _cx[breakLine] = idx > 0 && (idx + 1) % (_this2.props.wrapWordsAfter * 2) === 0 && string === '&nbsp;', _cx)))),
	
	              'aria-hidden': 'true'
	            },
	            _react2.default.createElement('span', { className: innerCell, dangerouslySetInnerHTML: { __html: string } })
	          );
	        })
	      );
	    }
	
	    return _react2.default.createElement('h1', { className: animatedHeading, dangerouslySetInnerHTML: { __html: this.props.text } });
	  };
	
	  _createClass(AnimatedHeading, [{
	    key: 'chunks',
	    get: function get() {
	      var splitRegex = this.props.splitRegex || this.props.splitAtWords ? new RegExp(/(\s+)/) : '';
	      return this.props.text.split(splitRegex).map(function (chunk) {
	        return chunk.replace(' ', '&nbsp;');
	      });
	    }
	  }]);
	
	  return AnimatedHeading;
	}(_react.Component);
	
	AnimatedHeading.propTypes = {
	  text: _propTypes2.default.string.isRequired,
	  splitRegex: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(RegExp)])),
	  splitAtWords: _propTypes2.default.bool,
	  animated: _propTypes2.default.bool,
	  wrapWordsAfter: _propTypes2.default.number
	};
	
	AnimatedHeading.defaultProps = {
	  splitAtWords: true,
	  animated: true
	};
	
	exports.default = AnimatedHeading;
	module.exports = exports['default'];

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.themePreviewFragment = exports.themePreview = exports.TeaserPreview = exports.GhostPreview = undefined;
	
	var _emotion = __webpack_require__(4);
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(51);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _toTitleCase = __webpack_require__(20);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _color = __webpack_require__(8);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _gray = __webpack_require__(10);
	
	var _gray2 = _interopRequireDefault(_gray);
	
	var _presets = __webpack_require__(3);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var _typography = __webpack_require__(7);
	
	var _functions = __webpack_require__(5);
	
	var _shapeButtonArrow = __webpack_require__(41);
	
	var _shapeButtonArrow2 = _interopRequireDefault(_shapeButtonArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _presets$animation = _presets2.default.animation,
	    curve = _presets$animation.curve,
	    speed = _presets$animation.speed;
	
	
	var browserChromeDotColor = _presets.colors.gray.calm;
	
	var browserChromeDotColors = [(0, _color2.default)(browserChromeDotColor).hsl().string(), (0, _color2.default)(browserChromeDotColor).hsl().alpha(0.76).string(), (0, _color2.default)(browserChromeDotColor).hsl().alpha(0.52).string()];
	
	var cover = {
	  position: 'absolute',
	  top: 0,
	  right: 0,
	  bottom: 0,
	  left: 0
	};
	
	var themePreview = /*#__PURE__*/(0, _reactEmotion.css)('position:relative;display:flex;flex-direction:column;justify-content:space-between;width:100vw;margin:0 0 ', (0, _functions.toRem)(_presets.baselineGrid * 4), ';background-color:', _presets.colors.ui.whisper, ';border-radius:', _presets2.default.radius.default, ';overflow:hidden;/* pseudo-background on hover */\n  &::before{content:\'\';display:block;', cover, ';z-index:', _presets.zIndex[1], ';opacity:0;}&:hover,&:active,&:focus{.themePreviewScreenshot{body:not(.touch-enabled) &{transform:translate3d(0,0,0);}}}', _functions.mqObj.palm, '{margin:0 0 ', (0, _functions.toRem)(_presets.baselineGrid * 4), ';}@media (min-width:480px){margin:0 0 ', (0, _functions.toRem)(_presets.baselineGrid * 4), ';}', _functions.mqObj.lap, '{width:calc(50% - ', (0, _functions.toRem)(_presets.baselineGrid * 2), ');}', _functions.mqObj.lapLarge, '{width:calc(50% - ', (0, _functions.toVW)(_presets.baselineGrid * 4), ');}', _functions.mqObj.desk, '{width:calc(33.3333% - ', (0, _functions.toVW)(_presets.baselineGrid * 5), ');}@media (min-width:1568px){margin:0 0 ', (0, _functions.toRem)(_presets.baselineGrid * 6), ';}', 'label:themePreview;');
	
	var themePreviewInfo = /*#__PURE__*/(0, _reactEmotion.css)('position:relative;z-index:', _presets.zIndex[2], ';padding:', (0, _functions.toRem)(_presets.baselineGrid * 4), ' ', (0, _functions.toRem)(_presets.baselineGrid * 3), ' ', (0, _functions.toRem)(_presets.baselineGrid * 3), ';', _functions.mqObj.palm, '{padding:', (0, _functions.toRem)(_presets.baselineGrid * 4), ' ', (0, _functions.toRem)(_presets.baselineGrid * 3), ' ', (0, _functions.toRem)(_presets.baselineGrid * 3), ';}@media (min-width:480px){padding:', (0, _functions.toRem)(_presets.baselineGrid * 4), ' ', (0, _functions.toRem)(_presets.baselineGrid * 4), ' ', (0, _functions.toRem)(_presets.baselineGrid * 3), ';}', _functions.mqObj.lapLarge, '{padding:', (0, _functions.toRem)(_presets.baselineGrid * 4), ';}', 'label:themePreviewInfo;');
	
	var themePreviewLink = /*#__PURE__*/(0, _reactEmotion.css)(_extends({}, cover, {
	  zIndex: _presets.zIndex[3]
	}), 'label:themePreviewLink;');
	
	var themePreviewName = /*#__PURE__*/(0, _reactEmotion.css)('padding:0;margin:0 0 ', (0, _functions.toRem)(_presets.baselineGrid * 0.5), ' 0;font-family:', _typography.options.headerFontFamily.join(','), ';font-size:', (0, _functions.toRem)(24), ';letter-spacing:', 1 / 21, 'em;', 'label:themePreviewName;');
	
	var themePreviewPlug = /*#__PURE__*/(0, _reactEmotion.css)('font-family:', _typography.options.headerFontFamily.join(','), ';font-weight:', _typography.options.headerWeight, ';', (0, _typography.adjustFontSizeTo)('16px'), ';line-height:1.3333;margin:0;color:', _presets.colors.gray.gunpowder, ';', 'label:themePreviewPlug;');
	
	var themePreviewScreenshot = /*#__PURE__*/(0, _reactEmotion.css)('position:relative;margin-left:', (0, _functions.toRem)(_presets.baselineGrid * 3), ';padding-top:', (0, _functions.toRem)(_presets.baselineGrid * 2), ';z-index:', _presets.zIndex[2], ';box-shadow:0 2px 5px ', (0, _gray2.default)(80), ';body:not(.touch-enabled) &{transform:translate3d(0,', _presets.baselineGrid * 2, 'px,0);transition:transform ', speed.medium, ' ', curve.easeInOutCirc, ';}', _functions.mqObj.palm, '{margin-left:', (0, _functions.toRem)(_presets.baselineGrid * 3), ';}@media (min-width:480px){margin-left:', (0, _functions.toRem)(_presets.baselineGrid * 4), ';}/* browser chrome */\n  &::before{content:\'\';display:block;position:absolute;height:', (0, _functions.toRem)(_presets.baselineGrid * 2), ';top:0;right:0;left:0;background-color:', (0, _gray2.default)(70, 'cool'), ';border-top-left-radius:5px;}&::after{content:\'\';display:block;position:absolute;width:6px;height:6px;top:', (0, _functions.toRem)(_presets.baselineGrid), ';left:', (0, _functions.toRem)(_presets.baselineGrid), ';background-color:', browserChromeDotColors[0], ';transform:translate(0,-50%);border-radius:50%;box-shadow:10px 0 0 0 ', browserChromeDotColors[1], ',20px 0 0 0 ', browserChromeDotColors[2], ';}', 'label:themePreviewScreenshot;');
	
	var screenshotWrapper = /*#__PURE__*/(0, _reactEmotion.css)('position:relative;padding-bottom:50vh;overflow:hidden;', _functions.mqObj.lap, '{padding-bottom:', (4 / 4 * 100).toFixed(_presets2.default.precision), '%;}', _functions.mqObj.deskLarge, '{padding-bottom:', (5 / 6 * 100).toFixed(_presets2.default.precision), '%;}', 'label:screenshotWrapper;');
	
	var screenshotFrame = /*#__PURE__*/(0, _reactEmotion.css)('position:absolute;top:0;right:0;bottom:0;left:0;', 'label:screenshotFrame;');
	
	var screenshot = /*#__PURE__*/(0, _reactEmotion.css)('label:screenshot;');
	
	var ghostPreviewColor = (0, _color2.default)(_presets.colors.ui.whisper).hsl().darken(0.1).string();
	
	var ghostPreview = /*#__PURE__*/(0, _reactEmotion.css)('background-color:', _presets.colors.ui.bright, ';&::after{content:\'\';display:block;', cover, ';z-index:', _presets.zIndex[0], ';box-shadow:inset 0 0 0 ', (0, _functions.toRem)(_presets.baselineGrid), ' ', _presets.colors.ui.whisper, ';}.themePreviewName{color:', ghostPreviewColor, ';user-select:none;}', 'label:ghostPreview;');
	
	var GhostPreview = function GhostPreview(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _reactEmotion.cx)(themePreview, ghostPreview, className) },
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.css)(themePreviewInfo)
	      },
	      _react2.default.createElement(
	        'h1',
	        {
	          className: (0, _emotion.css)(themePreviewName) + ' themePreviewName'
	        },
	        'Coming Soon'
	      )
	    )
	  );
	};
	
	GhostPreview.propTypes = {
	  className: _propTypes2.default.string
	};
	
	var teaserColor = (0, _gray2.default)(64, 'cool');
	var teaserBgColor = _presets.colors.ui.bright;
	var teaserBgColorHover = _presets.colors.pixelmoxie;
	var teaserGradStop = (0, _color2.default)(teaserBgColorHover).hsl().rotate(8).string();
	var teaserColorHover = (0, _color2.default)(teaserBgColorHover).isLight() ? _presets.colors.gray.gunpowder : _presets.colors.ui.bright;
	
	var teaserPreview = /*#__PURE__*/(0, _reactEmotion.css)('color:', teaserColor, ';background-color:', teaserBgColor, ';transition:color ', speed.default, ' ', curve.default, ';&::before{background-color:', teaserBgColorHover, ';background-image:linear-gradient(to top right,', teaserBgColorHover, ' 60%,', teaserGradStop, ');transform:translate(0,', (0, _functions.toRem)(_presets.baselineGrid * 4), ') scale(0.96);transition-property:opacity,transform;transition-duration:', speed.default, ';transition-timing-function:', curve.default, ';}&::after{content:\'\';display:block;', cover, ';z-index:', _presets.zIndex[0], ';box-shadow:inset 0 0 0 ', (0, _functions.toRem)(_presets.baselineGrid), ' ', teaserColor, ';transition:transform ', speed.default, ' ', curve.default, ';}&:hover,&:active,&:focus{color:', teaserColorHover, ';&::before{opacity:1;transform:translate(0,0) scale(1);}&::after{transform:scale(1.05);}}.themePreviewName{color:currentColor;user-select:none;}.teaser,.arrow{display:inline;vertical-align:middle;}.arrow{margin:0 ', (0, _functions.toRem)(_presets.baselineGrid * 0.5), ';width:1em;height:1em;transform:scale(1.25) translateY(-1px);transform-origin:center;fill:currentColor;}', 'label:teaserPreview;');
	
	var TeaserPreview = function TeaserPreview(_ref2) {
	  var className = _ref2.className,
	      teaser = _ref2.teaser,
	      linkTo = _ref2.linkTo;
	  return _react2.default.createElement(
	    'div',
	    { className: (0, _reactEmotion.cx)(themePreview, teaserPreview, className) },
	    _react2.default.createElement(_gatsbyLink2.default, { to: linkTo, className: (0, _emotion.css)(themePreviewLink)
	    }),
	    _react2.default.createElement(
	      'div',
	      {
	        className: (0, _emotion.css)(themePreviewInfo)
	      },
	      _react2.default.createElement(
	        'h1',
	        {
	          className: (0, _emotion.css)(themePreviewName) + ' themePreviewName'
	        },
	        _react2.default.createElement(
	          'span',
	          { className: 'teaser' },
	          (0, _toTitleCase2.default)(teaser)
	        ),
	        _react2.default.createElement(
	          'svg',
	          { className: 'arrow', viewBox: _shapeButtonArrow2.default.viewBox },
	          _react2.default.createElement('use', { xlinkHref: '#' + _shapeButtonArrow2.default.id })
	        )
	      )
	    )
	  );
	};
	
	TeaserPreview.propTypes = {
	  className: _propTypes2.default.string,
	  teaser: _propTypes2.default.string.isRequired,
	  linkTo: _propTypes2.default.string.isRequired
	};
	
	var ThemePreview = function (_Component) {
	  _inherits(ThemePreview, _Component);
	
	  function ThemePreview(props) {
	    _classCallCheck(this, ThemePreview);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      hover: false
	    };
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    return _this;
	  }
	
	  ThemePreview.prototype.handleMouseEnter = function handleMouseEnter() {
	    this.setState({ hover: true });
	  };
	
	  ThemePreview.prototype.handleMouseLeave = function handleMouseLeave() {
	    this.setState({ hover: false });
	  };
	
	  ThemePreview.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        theme = _props.theme,
	        coloured = _props.coloured;
	    var slug = theme.fields.slug;
	    var _theme$frontmatter = theme.frontmatter,
	        name = _theme$frontmatter.name,
	        plug = _theme$frontmatter.plug,
	        previewImage = _theme$frontmatter.previewImage,
	        previewBagRotate = _theme$frontmatter.previewBagRotate;
	
	
	    var bagColorRotation = parseInt(previewBagRotate, 10) || -8;
	
	    var backgroundColor = theme.fields.previewColors.background ? (0, _color2.default)(theme.fields.previewColors.background).hsl() : null;
	
	    var gradientStop = backgroundColor.rotate(bagColorRotation);
	
	    var titleColor = theme.fields.previewColors.title ? (0, _color2.default)(theme.fields.previewColors.title).hsl() : null;
	
	    var mouseEnter = /*#__PURE__*/(0, _reactEmotion.keyframes)('from{opacity:0;transform:translate(0,', (0, _functions.toRem)(_presets.baselineGrid * 1), ');}to{opacity:1;}', 'label:mouseEnter;');
	
	    var mouseLeave = /*#__PURE__*/(0, _reactEmotion.keyframes)('from{opacity:0;transform:translate(0,', (0, _functions.toRem)(_presets.baselineGrid * 1), ');}to{opacity:1;}', 'label:mouseLeave;');
	
	    var colouredBg = /*#__PURE__*/(0, _reactEmotion.css)('&::before{background-color:', backgroundColor.string(), ';background-image:linear-gradient(\n          to top right,', backgroundColor.string(), ' 60%,', gradientStop.string(), '\n        );transform:translate(0,', (0, _functions.toRem)(_presets.baselineGrid * 4), ') scale(0.96);transition-property:opacity,transform;transition-duration:', speed.default, ';transition-timing-function:', curve.default, ';}&::after{content:\'\';display:block;', cover, ';z-index:', _presets.zIndex[0], ';box-shadow:inset 0 0 0 ', (0, _functions.toRem)(_presets.baselineGrid), ' ', backgroundColor.string(), ';transition:transform ', speed.default, ' ', curve.default, ';}&:hover,&:active,&:focus{&::before{transform:translate(0,0) scale(1);}&::after{transform:scale(1.05);}}.themePreviewName,.themePreviewPlug{animation:', mouseEnter, ' ', speed.medium, ' ', curve.default, ';}', 'label:colouredBg;');
	
	    var colouredPreview = backgroundColor && titleColor ? /*#__PURE__*/(0, _reactEmotion.css)('background-color:', _presets.colors.gray.gunpowder, ';&::before{opacity:1;}.themePreviewName{color:', titleColor.string(), ';}.themePreviewPlug{color:', backgroundColor.isLight() ? _presets.colors.ui.copy : '#fff', ';}&:hover,&:active,&:focus{&::before{opacity:0;}.themePreviewName,.themePreviewPlug{color:', _presets.colors.ui.bright, ';}}&.mouse-enter{.themePreviewName,.themePreviewPlug{animation:', mouseEnter, ' ', speed.default, ' ', curve.default, ';}}&.mouse-leave{.themePreviewName,.themePreviewPlug{animation:', mouseLeave, ' ', speed.default, ' ', curve.default, ';}}', 'label:colouredPreview;') : '';
	
	    var colouredOnHover = backgroundColor && titleColor ? /*#__PURE__*/(0, _reactEmotion.css)('&::before{opacity:0;}.themePreviewName,.themePreviewPlug{transition:color ', speed.default, ' ', curve.default, ';}&:hover,&:active,&:focus{&::before{opacity:1;}.themePreviewName{color:', titleColor.string(), ';}.themePreviewPlug{color:', backgroundColor.isLight() ? _presets.colors.ui.copy : '#fff', ';}}', 'label:colouredOnHover;') : '';
	
	    return _react2.default.createElement(
	      'article',
	      {
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        className: (0, _reactEmotion.cx)([themePreview, colouredBg, function () {
	          return coloured ? colouredPreview : colouredOnHover;
	        }, function () {
	          return _this2.state.hover ? 'mouse-enter' : 'mouse-leave';
	        }])
	      },
	      _react2.default.createElement(_gatsbyLink2.default, { to: '/theme' + slug, className: (0, _emotion.css)(themePreviewLink)
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _emotion.css)(themePreviewInfo)
	        },
	        _react2.default.createElement(
	          'h1',
	          {
	            className: (0, _emotion.css)(themePreviewName) + ' themePreviewName'
	          },
	          name
	        ),
	        _react2.default.createElement(
	          'p',
	          {
	            className: (0, _emotion.css)(themePreviewPlug) + ' themePreviewPlug'
	          },
	          plug
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _emotion.css)(themePreviewScreenshot) + ' themePreviewScreenshot'
	        },
	        _react2.default.createElement(
	          'div',
	          {
	            className: (0, _emotion.css)(screenshotWrapper)
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: (0, _emotion.css)(screenshotFrame)
	            },
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _emotion.css)(screenshot)
	              },
	              _react2.default.createElement(_gatsbyImage2.default, { alt: name + ' - ' + plug, sizes: previewImage.childImageSharp.sizes })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ThemePreview;
	}(_react.Component);
	
	ThemePreview.propTypes = {
	  theme: _propTypes2.default.object.isRequired,
	  coloured: _propTypes2.default.bool
	};
	
	exports.default = ThemePreview;
	exports.GhostPreview = GhostPreview;
	exports.TeaserPreview = TeaserPreview;
	exports.themePreview = themePreview;
	var themePreviewFragment = exports.themePreviewFragment = '** extracted graphql fragment **';

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _emotion = __webpack_require__(4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _presets = __webpack_require__(3);
	
	var _functions = __webpack_require__(5);
	
	var _innerWrapper = __webpack_require__(9);
	
	var _innerWrapper2 = _interopRequireDefault(_innerWrapper);
	
	var _animatedHeading = __webpack_require__(55);
	
	var _animatedHeading2 = _interopRequireDefault(_animatedHeading);
	
	var _themePreview = __webpack_require__(112);
	
	var _themePreview2 = _interopRequireDefault(_themePreview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var padding = (0, _functions.fp)({
	  paddingTop: ['' + (0, _functions.toRem)(_presets.baselineGrid * 4), '' + (0, _functions.toRem)(_presets.baselineGrid * 4), '' + (0, _functions.toRem)(_presets.baselineGrid * 6)]
	});
	
	var themesGrid = /*#__PURE__*/(0, _emotion.css)('background-color:', _presets.colors.ui.bright, ';overflow:hidden;', 'label:themesGrid;');
	
	var themesGridPadded = /*#__PURE__*/(0, _emotion.css)(padding, ';', 'label:themesGridPadded;');
	
	var gridSpacer = /*#__PURE__*/(0, _emotion.css)(_themePreview.themePreview, ';height:0;margin:0 !important;', 'label:gridSpacer;');
	
	var themesGridWrapper = /*#__PURE__*/(0, _emotion.css)('display:flex;flex-wrap:wrap;justify-content:space-between;', 'label:themesGridWrapper;');
	
	var themesHeadingWrapper = /*#__PURE__*/(0, _emotion.css)('label:themesHeadingWrapper;');
	
	var ghostItem = /*#__PURE__*/(0, _emotion.css)('@media (max-width:', _presets.breakpoints.desk - 1, 'px){display:none;}', 'label:ghostItem;');
	
	var teaserItem = /*#__PURE__*/(0, _emotion.css)('@media (max-width:', _presets.breakpoints.lap - 1, 'px){display:none;}', 'label:teaserItem;');
	
	var ThemesGrid = function ThemesGrid(_ref) {
	  var _cx;
	
	  var themes = _ref.themes,
	      coloured = _ref.coloured,
	      title = _ref.title,
	      animatedTitle = _ref.animatedTitle,
	      titleWordsWrap = _ref.titleWordsWrap,
	      comingSoon = _ref.comingSoon,
	      teaser = _ref.teaser,
	      teaserLink = _ref.teaserLink,
	      children = _ref.children;
	  return _react2.default.createElement(
	    'div',
	    {
	      className: (0, _emotion.css)((0, _emotion.cx)(themesGrid, (_cx = {}, _cx[themesGridPadded] = !title, _cx)))
	    },
	    children,
	    title && _react2.default.createElement(
	      _innerWrapper2.default,
	      { className: themesHeadingWrapper },
	      _react2.default.createElement(_animatedHeading2.default, { text: title, animated: animatedTitle, wrapWordsAfter: titleWordsWrap })
	    ),
	    _react2.default.createElement(
	      _innerWrapper2.default,
	      { className: themesGridWrapper },
	      themes.sort(function (a, b) {
	        return a.node.fields.order - b.node.fields.order;
	      }).map(function (_ref2) {
	        var node = _ref2.node;
	        return _react2.default.createElement(_themePreview2.default, { key: node.id, theme: node, coloured: coloured });
	      }),
	      comingSoon && _react2.default.createElement(_themePreview.GhostPreview, { className: ghostItem }),
	      teaser && _react2.default.createElement(_themePreview.TeaserPreview, { className: teaserItem, teaser: 'Browse all themes', linkTo: teaserLink }),
	      _react2.default.createElement('div', { className: gridSpacer }),
	      _react2.default.createElement('div', { className: gridSpacer })
	    )
	  );
	};
	
	ThemesGrid.propTypes = {
	  themes: _propTypes2.default.array.isRequired,
	  coloured: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  animatedTitle: _propTypes2.default.bool,
	  titleWordsWrap: _propTypes2.default.number,
	  comingSoon: _propTypes2.default.bool,
	  teaser: _propTypes2.default.bool,
	  teaserLink: _propTypes2.default.string,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};
	
	ThemesGrid.defaultProps = {
	  coloured: false,
	  animatedTitle: true
	};
	
	exports.default = ThemesGrid;
	module.exports = exports['default'];

/***/ }),

/***/ 315:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(33);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _themesGrid = __webpack_require__(113);
	
	var _themesGrid2 = _interopRequireDefault(_themesGrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TumblrThemes = function TumblrThemes(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _themesGrid2.default,
	    {
	      themes: data.allMarkdownRemark.edges,
	      title: 'Lovingly crafted Tumblr themes for you.',
	      titleWordsWrap: 3,
	      comingSoon: true
	    },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'The Best-Designed Tumblr Themes for Bloggers and Creatives'
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: 'Download the most beautiful and effective Tumblr themes for photographers, designers, illustrators, bloggers, and creatives.'
	      })
	    )
	  );
	};
	
	TumblrThemes.propTypes = {
	  data: _propTypes2.default.object
	};
	
	exports.default = TumblrThemes;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tumblr-themes-js-ef2ea9936f190c27b6ef.js